
      import { DwApp } from 'https://cdn.ing.com/dealwise-web/2.8.5/de/es-modules/dw-app.js';

      if(!window.customElements.get('dw-app')) {
        window.customElements.define('dw-app', DwApp);
        
        const dwApp = window.document.createElement('dw-app');
        const apiLink = 'https://api2.dealwise.app';

        dwApp.setAttribute('direct-api', apiLink);
        document.querySelector('body').appendChild(dwApp);
      }
    